module.exports = __webpack_public_path__ + "static/media/menu-white.4ca7fa4c.svg";